import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useRestoreScroll from "../../hooks/useRestoreScroll.js";

const Terms = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("definitions");
  useRestoreScroll();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const sections = [
    { id: "definitions", title: "1. Definitions" },
    { id: "eligibility", title: "2. Eligibility" },
    { id: "scope", title: "3. Scope of Services" },
    { id: "obligations", title: "4. User Obligations" },
    { id: "fees", title: "5. Fees and Payments" },
    { id: "disclaimer", title: "6. Disclaimer of Liability" },
    { id: "content", title: "7. Content and Data" },
    { id: "privacy", title: "8. Data Privacy" },
    { id: "ip", title: "9. Intellectual Property" },
    { id: "termination", title: "10. Suspension & Termination" },
    { id: "limitation", title: "11. Limitation of Liability" },
    { id: "law", title: "12. Governing Law" },
    { id: "contact", title: "13. Contact" },
  ];

  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const sectionTitleStyle = {
    fontSize: "24px",
    fontWeight: 600,
    color: "#1F2937",
    margin: "48px 0 24px 0",
    paddingTop: "20px",
  };

  const contentStyle = {
    fontSize: "16px",
    lineHeight: 1.7,
    color: "#374151",
  };

  const listStyle = {
    paddingLeft: "24px",
    margin: "16px 0",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#F9FAFB",
        fontFamily: '"Red Hat Display", sans-serif',
      }}
    >
      {/* Header */}
      <div
        style={{
          background: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
          padding: "16px 0",
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              cursor: "pointer",
            }}
            onClick={() => {
              const userType = userDataService.getUserType();
              if (userType === 'ADMIN' || userType === 'CONTENT_ADMIN') {
                return navigate(userDataService.getDefaultRedirect());
              }
              navigate("/social");
            }}
          >
            <img
              src="/icons/navbar/Sulhafa_Beta_Logo.png"
              alt="Sulhafa Logo"
              width={120}
              height={40}
            />
          </div>

          <button
            onClick={() => navigate(-1)}
            style={{
              background: "transparent",
              border: "1px solid #E5E7EB",
              borderRadius: "8px",
              padding: "8px 16px",
              fontFamily: '"Red Hat Display", sans-serif',
              fontSize: "14px",
              color: "#6B7280",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "#F9FAFB";
              e.target.style.borderColor = "#D1D5DB";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "transparent";
              e.target.style.borderColor = "#E5E7EB";
            }}
          >
            ← Back
          </button>
        </div>
      </div>

      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "32px 24px",
          display: "flex",
          gap: "32px",
        }}
      >
        {/* Sidebar Navigation */}
        <div
          style={{
            width: "280px",
            flexShrink: 0,
          }}
        >
          <div
            style={{
              background: "#FFFFFF",
              borderRadius: "12px",
              padding: "24px",
              border: "1px solid #E5E7EB",
              position: "sticky",
              top: "100px",
              maxHeight: "calc(100vh - 120px)",
              overflow: "auto",
            }}
          >
            <h3
              style={{
                fontSize: "18px",
                fontWeight: 600,
                color: "#1F2937",
                margin: "0 0 20px 0",
              }}
            >
              Table of Contents
            </h3>
            <nav>
              {sections.map((section) => (
                <button
                  key={section.id}
                  onClick={() => scrollToSection(section.id)}
                  style={{
                    display: "block",
                    width: "100%",
                    textAlign: "left",
                    border: "none",
                    padding: "12px 16px",
                    margin: "4px 0",
                    borderRadius: "8px",
                    fontFamily: '"Red Hat Display", sans-serif',
                    fontSize: "14px",
                    color: activeSection === section.id ? "#8548A8" : "#6B7280",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    fontWeight: activeSection === section.id ? 500 : 400,
                    background:
                      activeSection === section.id ? "#F3E8FF" : "transparent",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  onMouseEnter={(e) => {
                    if (activeSection !== section.id) {
                      e.target.style.background = "#F9FAFB";
                      e.target.style.color = "#374151";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeSection !== section.id) {
                      e.target.style.background = "transparent";
                      e.target.style.color = "#6B7280";
                    }
                  }}
                  title={section.title}
                >
                  {section.title}
                </button>
              ))}
            </nav>
          </div>
        </div>

        {/* Main Content */}
        <div
          style={{
            flex: 1,
            background: "#FFFFFF",
            borderRadius: "12px",
            padding: "40px",
            border: "1px solid #E5E7EB",
          }}
        >
          <div
            style={{
              maxWidth: "800px",
              margin: "0 auto",
            }}
          >
            {/* Page Header */}
            <div
              style={{
                textAlign: "center",
                marginBottom: "48px",
              }}
            >
              <h1
                style={{
                  fontSize: "32px",
                  fontWeight: 700,
                  color: "#1F2937",
                  margin: "0 0 16px 0",
                }}
              >
                Sulhafa Platform – Terms & Conditions
              </h1>
              <p
                style={{
                  fontSize: "16px",
                  color: "#6B7280",
                  margin: "0 0 8px 0",
                }}
              >
                Last updated:{" "}
                {new Date().toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>
            </div>

            {/* Introduction */}
            <div style={contentStyle}>
              <h2
                style={{
                  fontSize: "24px",
                  fontWeight: 600,
                  color: "#1F2937",
                  marginBottom: "20px",
                }}
              >
                Introduction
              </h2>
              <p>
                This Agreement (“Terms” or “Agreement”) governs your access to and
                use of the Sulhafa mobile application and website (the
                “Platform”), operated by Sulhafa. By using the Platform, you agree
                to these Terms and all applicable laws and regulations in the
                Kingdom of Saudi Arabia.
              </p>
            </div>

            {/* 1. Definitions */}
            <section id="definitions">
              <h2 style={{ ...sectionTitleStyle, marginTop: "32px" }}>
                1. Definitions
              </h2>
              <div style={contentStyle}>
                <ul style={listStyle}>
                  <li>
                    <strong>User / Pet Guardian:</strong> Any individual who
                    registers and uses the Platform as a social networking hub,
                    and to request pet-related services or products.
                  </li>
                  <li>
                    <strong>Service Providers:</strong> Independent third-party
                    veterinarians, pet shops, and service suppliers registered on
                    the Platform.
                  </li>
                  <li>
                    <strong>Platform:</strong> The Sulhafa digital platform
                    providing access to pet social networking hub, pet care
                    services, suppliers, and professionals.
                  </li>
                </ul>
              </div>
            </section>

            {/* 2. Eligibility */}
            <section id="eligibility">
              <h2 style={sectionTitleStyle}>2. Eligibility</h2>
              <div style={contentStyle}>
                <p>
                  By using the Platform, you represent and warrant that you are at
                  least 18 years old and have the legal capacity to enter into
                  binding agreements.
                </p>
              </div>
            </section>

            {/* 3. Scope of Services */}
            <section id="scope">
              <h2 style={sectionTitleStyle}>3. Scope of Services</h2>
              <div style={contentStyle}>
                <p>
                  Sulhafa acts solely as a digital intermediary connecting Users
                  with verified Service Providers and Suppliers. The Platform
                  facilitates:
                </p>
                <ul style={listStyle}>
                  <li>Booking of veterinary or grooming services.</li>
                  <li>Purchasing pet-related products.</li>
                  <li>Communication between Users and Providers.</li>
                </ul>
                <p>
                  Sulhafa does not own, operate, or directly provide any
                  veterinary or pet care services.
                </p>
              </div>
            </section>

            {/* 4. User Obligations */}
            <section id="obligations">
              <h2 style={sectionTitleStyle}>4. User Obligations</h2>
              <div style={contentStyle}>
                <ol
                  type="a"
                  style={{ paddingLeft: "24px", margin: "16px 0" }}
                >
                  <li>
                    Provide accurate, complete, and up-to-date registration
                    information.
                  </li>
                  <li>Maintain confidentiality of your account credentials.</li>
                  <li>
                    Use the Platform lawfully and refrain from any misuse, fraud,
                    or abuse of service features.
                  </li>
                  <li>
                    Refrain from uploading harmful, offensive, or misleading
                    content.
                  </li>
                  <li>
                    Refrain from typing offensive, harmful, and misleading
                    comments.
                  </li>
                </ol>
              </div>
            </section>

            {/* 5. Fees and Payments */}
            <section id="fees">
              <h2 style={sectionTitleStyle}>5. Fees and Payments</h2>
              <div style={contentStyle}>
                <ol
                  type="a"
                  style={{ paddingLeft: "24px", margin: "16px 0" }}
                >
                  <li>
                    Payments for services or products are processed through secure
                    payment gateways integrated into the Platform.
                  </li>
                  <li>
                    All payments are subject to applicable VAT and transaction
                    fees.
                  </li>
                  <li>
                    Refunds, if any, shall be processed in accordance with the
                    cancellation or refund policy of the relevant Service
                    Provider.
                  </li>
                </ol>
              </div>
            </section>

            {/* 6. Disclaimer of Liability */}
            <section id="disclaimer">
              <h2 style={sectionTitleStyle}>6. Disclaimer of Liability</h2>
              <div style={contentStyle}>
                <p>
                  The User acknowledges and agrees that Sulhafa Platform is not
                  responsible or liable for the performance, actions, or omissions
                  of independent Service Providers. In the event of any loss,
                  damage, or injury resulting from a Service Provider’s act or
                  negligence, the User agrees to seek remedies directly from the
                  respective Service Provider without holding Sulhafa liable in
                  any manner.
                </p>
              </div>
            </section>

            {/* 7. Content and Data */}
            <section id="content">
              <h2 style={sectionTitleStyle}>7. Content and Data</h2>
              <div style={contentStyle}>
                <ol
                  type="a"
                  style={{ paddingLeft: "24px", margin: "16px 0" }}
                >
                  <li>
                    The User may upload pet photos, information, or medical
                    records for service facilitation.
                  </li>
                  <li>
                    The User grants Sulhafa a non-exclusive right to store and use
                    such data for service management, record-keeping, and
                    marketing purposes, provided no personal identifying
                    information is disclosed without consent.
                  </li>
                  <li>
                    Sulhafa reserves the right to anonymize and analyze aggregated
                    data to improve platform services.
                  </li>
                </ol>
              </div>
            </section>

            {/* 8. Data Privacy */}
            <section id="privacy">
              <h2 style={sectionTitleStyle}>8. Data Privacy</h2>
              <div style={contentStyle}>
                <p>
                  Sulhafa processes personal data in accordance with the Saudi
                  Personal Data Protection Law (PDPL) and other applicable laws.
                  For details on how data is collected and processed, please refer
                  to our privacy and data protection, available on the Platform.
                </p>
              </div>
            </section>

            {/* 9. Intellectual Property */}
            <section id="ip">
              <h2 style={sectionTitleStyle}>9. Intellectual Property</h2>
              <div style={contentStyle}>
                <p>
                  All copyrights, trademarks, and content displayed on the
                  Platform are owned by Sulhafa or licensed to it. Users may not
                  copy, reproduce, or distribute any content without Sulhafa's
                  prior written permission. Any unauthorized use of Sulhafa's
                  copyrighted material shall subject the user to legal action and
                  claims by Sulhafa.
                </p>
              </div>
            </section>

            {/* 10. Suspension and Termination */}
            <section id="termination">
              <h2 style={sectionTitleStyle}>10. Suspension and Termination</h2>
              <div style={contentStyle}>
                <p>
                  Sulhafa reserves the right to suspend or terminate any User
                  account that violates these Terms, engages in illegal activity,
                  or misuses the Platform.
                </p>
              </div>
            </section>

            {/* 11. Limitation of Liability */}
            <section id="limitation">
              <h2 style={sectionTitleStyle}>11. Limitation of Liability</h2>
              <div style={contentStyle}>
                <p>
                  To the maximum extent permitted by law, Sulhafa shall not be
                  liable for:
                </p>
                <ul style={listStyle}>
                  <li>Any indirect, incidental, or consequential damages.</li>
                  <li>
                    Any service errors, delays, or unavailability caused by
                    Service Providers or third-party systems.
                  </li>
                  <li>
                    Any loss arising from reliance on data or advice obtained
                    through the Platform.
                  </li>
                </ul>
              </div>
            </section>

            {/* 12. Governing Law and Jurisdiction */}
            <section id="law">
              <h2 style={sectionTitleStyle}>
                12. Governing Law and Jurisdiction
              </h2>
              <div style={contentStyle}>
                <p>
                  These Terms are governed by and construed in accordance with the
                  laws of the Kingdom of Saudi Arabia. Any disputes arising out of
                  or relating to this Agreement shall be subject to the exclusive
                  jurisdiction of the courts of Riyadh.
                </p>
              </div>
            </section>

            {/* 13. Contact */}
            <section id="contact">
              <h2 style={sectionTitleStyle}>13. Contact</h2>
              <div style={contentStyle}>
                <p>
                  For inquiries, complaints, or data-related requests, please
                  contact:
                </p>
                <p style={{ marginTop: "8px" }}>
                  <strong>Email:</strong> support@sulhafa.com
                </p>
              </div>
            </section>

            {/* User Consent Note */}
            <section
              style={{
                marginTop: "48px",
                padding: "24px",
                background: "#F3F4F6",
                borderRadius: "12px",
                border: "1px solid #E5E7EB",
                textAlign: "center",
              }}
            >
              <h3
                style={{
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#1F2937",
                  marginBottom: "8px",
                }}
              >
                User Consent
              </h3>
              <p style={{ fontSize: "16px", color: "#4B5563" }}>
                By clicking “I Agree” you acknowledge that you have read,
                understood, and accepted these Terms and the Privacy Policy.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
